<template>
    <div id="sig-preview" v-html="html"></div>
</template>
<script>
export default {
  name: "SignatureRender",
  props: ['html'],
};
</script>

<style>
#sig-preview html{
  box-sizing: content-box;
}

#sig-preview img{
  max-width: none;
}
#sig-preview table{
  border-collapse: collapse;
  border-spacing: 0;
}
#sig-preview td, 
#sig-preview th{
  padding: 0;
  text-align: inherit;
}
</style>